export const uploadKeyMap = (uploadKey: string) => {
  switch (uploadKey) {
    case 'insv-upload':
      return 'Insv Upload';
    case 'media-upload':
      return 'Media Hub';
    default:
      return uploadKey;
  }
};

export const getStateColor = (uploadState: string) => {
  switch (uploadState) {
    case 'error':
      return 'bg-destructive';
    case 'completed':
      return 'bg-success';
    case 'paused':
      return 'bg-amber-400';
    case 'uploading':
      return 'bg-primary';
    default:
      return 'bg-primary';
  }
};
